import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "blue",
  breakpoints: {
    xs: "475px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
  },
  defaultRadius: "md",
});
